import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createBrowserRouter } from "react-router-dom";

import { FeedPage } from "../features/feed/FeedPage";
import { WatchlistPage } from "../features/feed/WatchlistPage";
import { PlayerPage } from "../features/entities/PlayerPage";
import { TeamPage } from "../features/entities/TeamPage";
import { TournamentPage } from "../features/tournaments/TournamentPage";
import { TournamentsPage } from "../features/tournaments/TournamentsPage";
import { DotaMatchPage } from "../features/matches/DotaMatchPage";
import { CounterStrikeMatchPage } from "../features/matches/CounterStrikeMatchPage";
import { PreferencesProvider } from "./Preferences";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

const router = createBrowserRouter([
  {
    path: "/",
    element: <FeedPage />,
  },
  {
    path: "/watchlist",
    element: <WatchlistPage />,
  },
  {
    path: "/players/:wiki/:slug",
    element: <PlayerPage />,
  },
  {
    path: "/teams/:wiki/:slug",
    element: <TeamPage />,
  },
  {
    path: "/tournaments/:wiki/:slug",
    element: <TournamentPage />,
  },
  {
    path: "/tournaments/dota2/:slug/matches/:matchKey",
    element: <DotaMatchPage />,
  },
  {
    path: "/tournaments/counterstrike/:slug/matches/:matchKey",
    element: <CounterStrikeMatchPage />,
  },
  {
    path: "/tournaments",
    element: <TournamentsPage />,
  },
  {
    path: "/organizations/:wiki/:slug",
    element: <TeamPage />,
  },
  {
    path: "*",
    element: <FeedPage />,
  },
]);

export function FasterPediaApp() {
  return (
    <QueryClientProvider client={queryClient}>
      <PreferencesProvider><RouterProvider router={router} /></PreferencesProvider>
    </QueryClientProvider>
  );
}
